import { Injectable } from '@angular/core';

import { Query, gql } from 'apollo-angular';

import { Category, QueryTopLevelProductNavigationArgs } from '@hdms/shared/common-types';

export interface TopLevelProductNavigationResponse {
  topLevelProductNavigation: Category[];
}

@Injectable({
  providedIn: 'root'
})
export class HeaderProductCategoriesGqlService extends Query<
  TopLevelProductNavigationResponse,
  QueryTopLevelProductNavigationArgs
> {
  override document = gql`
    query HeaderProductCategories($localization: LocalizationInput!) {
      topLevelProductNavigation(localization: $localization) {
        id
        title
        thumbnail
      }
    }
  `;
}
